/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

// This is used for unknown system locales, or when we don't have a mapping in the table below
export const FALLBACK_LOCALE = 'en_GB';

export const DEFAULT_FALLBACK_SHORT_LOCALE = 'en';

// This is used for the physical fallback translation, ie, which .json file is used in case of missing translations
export const DEFAULT_TRANSLATION_FILE = 'en_US';

// This array represents the language codes for RTL locales, expand it as per the need
export const RTLLanguageCodes = ['ar'];

// These locale/Language mapping is based on the excel-sheet present in MVPC-6960
// If we add support for a new locale there, we will need to add it here
export const LANGUAGE_MAPPING = new Map([
    ['ar', ['ar_SA', 'ar_EG']],
    ['bg', ['bg_BG']],
    ['ca', ['ca_ES']],
    ['cs', ['cs_CZ']],
    ['da', ['da_DK']],
    ['de', ['de_DE', 'de_AT', 'de_CH']],
    ['el', ['el_GR']],
    ['en', ['en_GB']],
    ['en_MX', ['en_US']],
    ['en_US', ['en_GB']],
    ['es', ['es_MX', 'es_US', 'es_ES']],
    ['es_ES', ['es_MX', 'es_US']],
    ['fa', ['fa_IR']],
    ['fi', ['fi_FI']],
    ['fr', ['fr_FR']],
    ['hr', ['hr_HR']],
    ['hu', ['hu_HU']],
    ['in', ['in_ID']],
    ['id', ['id_ID']],
    ['it', ['it_IT']],
    ['iw', ['iw_IL']],
    ['he', ['he_IL']],
    ['ja', ['ja_JP']],
    ['ka', ['ka_GE']],
    ['ko', ['ko_KR']],
    ['lt', ['lt_LT']],
    ['lv', ['lv_LV']],
    ['ms', ['ms_MY']],
    ['nb', ['nb_NO']],
    ['no', ['nb_NO']],
    ['nl', ['nl_NL']],
    ['pl', ['pl_PL']],
    ['pt', ['pt_BR', 'pt_PT']],
    ['pt_PT', ['pt_BR']],
    ['ro', ['ro_RO']],
    ['ru', ['ru_RU']],
    ['sk', ['sk_SK']],
    ['sl', ['sl_SI']],
    ['sr', ['sr_RS']],
    ['sv', ['sv_SE']],
    ['th', ['th_TH']],
    ['tl', ['tl_PH']],
    ['tr', ['tr_TR']],
    ['uk', ['uk_UA']],
    ['vi', ['vi_VN']],
    ['zh', ['zh_CN']],
    ['zh_HK', ['zh_TW', 'zh_CN']],
    ['zh_MO', ['zh_TW', 'zh_CN']],
    ['zh_MY', ['zh_CN']],
    ['zh_SG', ['zh_CN']],
    ['zh_TW', ['zh_HK', 'zh_CN']],
    ['zh_CHT', ['zh_TW']],
    ['zh_CHS', ['zh_CN']],
    ['zh-Latn_CN', ['zh_CN']]
]);
